import Router from 'vue-router'


import List from '../pages/familial/List.vue'

import store1 from "../store/index.js";
import Landing from "../pages/common-apps/Landing.vue";

const baseRoutes = [
  {
    path: '/',
    redirect: { name: 'Landing' }
  },
  {
    path: '/landing',
    name: 'Landing',
    component: Landing,
    meta: { bodyClass: 'landing-page' }
  }
]

const familialRoutes = [
  {
    path: '/list',
    name: 'Familial List',
    component: List,
    meta: { bodyClass: 'month-page', requiresAuth: true }
  }
]


const routes = baseRoutes.concat(familialRoutes)


const routerFamilial = new Router({
  routes,
  mode: 'history',
  base: 'fam'
})

routerFamilial.beforeEach((to, from, next) => {
  // vueBodyClass.guard(to, next)
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store1.getters['account/isAuthenticated']) {
      next()
      return
    }
    next('/landing')
  } else {
    next()
  }
})

export default routerFamilial

